export default {
  loginPage: 'components.views.sign-up-view.return-link.loginPage'
}
